import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  viewPortCalculatedWidth: {
    width: 'calc(100vw - 150px)',
  },
}));

const ViewPortGridWrapper = ({ fullResponsive, children }) => {
  const classes = useStyles();
  return <div className={clsx({ [classes.viewPortCalculatedWidth]: !fullResponsive })}>{children}</div>;
};

export default ViewPortGridWrapper;
